// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_R0enEWu1ATmWMvf8PvZlcoMkcD4dcVI",
  authDomain: "teeday-web.firebaseapp.com",
  projectId: "teeday-web",
  storageBucket: "teeday-web.appspot.com",
  messagingSenderId: "828656922072",
  appId: "1:828656922072:web:f2222cb021f221f44f16ad",
  measurementId: "G-L86SD2CLRT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default analytics;
